import Logowall from "./Logowall";
export default Logowall;